@if (activationDetails$ | async; as activationDetails) {
  <div class="p-4 md:mx-auto md:w-1/2 md:p-12 md:shadow-lg">
    @if (!errorHandled && activationDetails.error; as error) {
      <ng-container *transloco="let t; prefix: 'agencyactivation.error'">
        <rma-callout [message]="t(error)" calloutType="error" />
        <div class="my-2 w-full text-center">
          @if (error === 'loggedIn') {
            <button type="button" (click)="onLogout()" mat-stroked-button color="primary">
              {{ t('logOut') }}
            </button>
          }
        </div>
      </ng-container>
    } @else {
      <header *transloco="let t; prefix: 'agencyactivation.header'" class="pb-4 text-center">
        <h1 class="text-3xl font-bold">{{ t('title', { name: activationDetails.agency.name }) }}</h1>
        @if (!activationDetails.isExistingAccount) {
          <p class="pt-4">{{ t('description') }}</p>
        }
      </header>
      <form *transloco="let t; prefix: 'agencyactivation.form'" class="mx-auto space-y-4 lg:w-7/12" [formGroup]="form">
        @if (!activationDetails.isExistingAccount) {
          <mat-form-field class="block w-full">
            <mat-label>{{ t('alias.label') }}</mat-label>
            <input matInput formControlName="alias" required />
            <mat-hint>{{ t('alias.hint') }}</mat-hint>
            <mat-error />
          </mat-form-field>
          <mat-form-field class="block w-full">
            <mat-label>{{ t('password.label') }}</mat-label>
            <rma-password formControlName="password" required />
            <mat-hint>{{ t('password.hint') }}</mat-hint>
            <mat-error />
          </mat-form-field>
        }
        <mat-checkbox formControlName="acceptTermsAndConditions" color="primary">
          <span [innerHtml]="t('terms.label')"></span>
          @if (form.controls.acceptTermsAndConditions.touched && form.controls.acceptTermsAndConditions.invalid) {
            <mat-error>
              {{ t('acceptTermsAndConditions.error') }}
            </mat-error>
          }
        </mat-checkbox>
        @if (serverError$ | async; as serverError) {
          <div class="rounded bg-warning-50 p-4 text-center text-white">
            {{ serverError }}
          </div>
        }
        <div *transloco="let t; prefix: 'agencyactivation.form.actions'" class="mt-8 flex justify-end gap-2">
          <button type="button" (click)="onDeclineInvitation()" mat-button>{{ t('decline') }}</button>
          <button type="submit" [disabled]="submitting$ | async" (click)="onAcceptInvitation()" mat-raised-button color="primary">
            <span> {{ t('accept') }}</span>
          </button>
        </div>
      </form>
    }
  </div>
}
